export const castformatdata = movieDataExists => {
  if (movieDataExists.Cast) {
    const castEndata = movieDataExists.Cast.map(e => /* `${e.name} ${e.roleName}` */ ({
      PK: e.PK,
      SK: e.SK,
      personID: e.personID,
      personUUID: e.personUUID,
      name_En: e.name_En,
      name_Te: e.name_Te,
      role: `${e.name_En} ${e.roleName_En ? e.roleName_En : ''}`,
      roleName_En: `${e.roleName_En ? e.roleName_En : ''}`,
      roleName_Te: `${e.roleName_Te ? e.roleName_Te : ''}`,
      weight: e.weight,
      posterURL: e.posterURL,
      isAnonymous: e.isAnonymous,
      GSIPersonStatusAndPersonID: e.GSIPersonStatusAndPersonID,
    }))
    return castEndata.sort((a, b) => parseFloat(a.weight) - parseFloat(b.weight))
  }

  return []
}

export const castformatdatate = movieDataExists => {
  if (movieDataExists.Cast) {
    const CastTeSort = movieDataExists.Cast.sort(
      (a, b) => parseFloat(a.weight) - parseFloat(b.weight),
    )
    return CastTeSort.map(
      e => `${e.name_Te ? e.name_Te : ''} ${e.roleName_Te ? `గా ${e.roleName_Te}` : ''}`,
    )
  }

  return []
}
